import React from 'react'

import classNames from './EmptyNotice.css'

export default function EmptyNotice ({ heading, text }) {
  return (
    <div className={classNames.wrapper}>
      <div className={classNames.heading}>
        {heading}
      </div>
      <p>
        {text}
      </p>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/EmptyNotice.js